import styled from '@mui/system/styled';
import Chip from '@mui/material/Chip';
import CTypography from 'components/CTypography';
import { IconButton } from '@mui/material';

export const IconButtonStyled = styled(IconButton)({
  color: '#0000008A',
  position: 'absolute',
  bottom: 0,
  right: 0,
  background: 'white',
  boxShadow: '1px 1px 4px 2px #979797',
  '&: hover': {
    background: 'white',
  },
});

export const StackItem = styled('div')({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '20px',
  paddingTop: '4px',
  '& span': {
    paddingLeft: '8px',
    paddingTop: '2px',
    display: 'inline-block',
  },
});

export const AvatarContainer = styled('div')({
  width: '80px',
  marginRight: '24px',
  position: 'relative',
});

export const ChipWrap = styled('div')({
  fontSize: '20px',
  fontWeight: 700,
  lineHeight: '32px',
  color: '#000000DE',
  paddingTop: '10px',
  paddingBottom: '2px',
});

export const ChipStyled = styled(Chip)({
  color: 'white',
  background: '#5555FF',
  fontWeight: 400,
  fontSize: '13px',
  lineHeight: '18px',
});

export const CTypographyStyled = styled(CTypography)({
  fontWeight: '600',
  fontSize: '14px',
  lineHeight: '22px',
  color: '#000000DE',
  paddingTop: '16px',
  paddingLeft: '16px',
});

export const LabelField = styled('label')({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  marginBottom: 0,
  paddingTop: '7px',
  paddingLeft: '16px',
  color: '#00000099',
  width: 288,
});

export const CTypographyProfile = styled(CTypography)({
  fontWeight: '600',
  fontSize: '14px',
  lineHeight: '22px',
  color: '#000000DE',
  paddingTop: '16px',
  paddingLeft: '16px',
});

export const LabelFieldProfile = styled('label')({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  marginBottom: 0,
  paddingTop: '7px',
  paddingLeft: '16px',
  color: '#00000099',
});
